import { Option } from 'components/common/types/DropdownItem.types';
import { LocationLabel, LocationOption as LocationLabelKey, ReferenceLocation } from 'store/userOptions/reducer.types';
import { CodeNameModel } from 'components/common/types';
import { sortByName } from 'utils/sortByName';

const transformLocationToOption = (subOptions: CodeNameModel[], categoryType: string, category: string): Option[] => {
  return sortByName(
    subOptions.map(({ code, name }) => ({
      code,
      name,
      selectable: true,
      parentCode: category,
    })),
  );
};

export const transformLocationData = (locationOptions: ReferenceLocation): Option[] => {
  return sortByName(
    Object.entries(locationOptions).reduce<Option[]>((acc, [category, locations]) => {
      if (locations && locations.length > 0 && category !== LocationLabelKey.COUNTRY) {
        const categoryType = LocationLabel[category as LocationLabelKey];
        const children = transformLocationToOption(locations, categoryType, category);

        acc.push({
          code: category,
          name: categoryType,
          selectable: false,
          children,
        });
      }
      return acc;
    }, []),
  );
};
